<openpay-settings-header-component></openpay-settings-header-component>
<div class="settings-page" *ngIf="!loader && !attemptErrorSection && !errorSection">
  <div class="openpay-settings-section">

    <div class="settings-header">
      <h1>Ajustes</h1>
    </div>

    <div class="divider"></div>

    <ng-container *ngIf="countryCode === 'MX'">
    <div class="settings-msi">
      <p>Seleccione las opciones de meses sin intereses (MSI) que ofrecerás a tus clientes</p>

      <div class="settings-msi-options">
        <div class="settings-msi-option">
          <label class="form-control">
            <input type="checkbox" name="3" [checked]="payments.includes('3')" (change)="checkboxChange($event)" value="3"/>
            3 MSI
          </label>
          <p class="settings-msi-subtext">Compra mínima $300.00 MXN</p>
        </div>

        <div class="settings-msi-option">
          <label class="form-control">
            <input type="checkbox" name="6" [checked]="payments.includes('6')" (change)="checkboxChange($event)" value="6"/>
            6 MSI
          </label>
          <p class="settings-msi-subtext">Compra mínima $600.00 MXN</p>
        </div>

        <div class="settings-msi-option">
          <label class="form-control">
            <input type="checkbox" name="9" [checked]="payments.includes('9')" (change)="checkboxChange($event)" value="9"/>
            9 MSI
          </label>
          <p class="settings-msi-subtext">Compra mínima $900.00 MXN</p>
        </div>

        <div class="settings-msi-option">
          <label class="form-control">
            <input type="checkbox" name="12" [checked]="payments.includes('12')" (change)="checkboxChange($event)" value="12" />
            12 MSI
          </label>
          <p class="settings-msi-subtext">Compra mínima $1200.00 MXN</p>
        </div>
      </div>

      <div class="settings-msi-note">
        <img src="assets/img/communication/info@2x.png" alt="Info Transacciones msi openpay">
        <span class="msi-note">
          Por pagos a MSI cobraremos la comisión base + la comisión de acuerdo al plazo seleccionado + IVA. Puedes <span (click)="backTo('fees')" class="msi-note-link">Ir al panel de control</span> para consultar las comisiones que aplican a tu negocio o llamar al (55) 50 22 04 04.
      </span>
      </div>
    </div>
    </ng-container>
    <ng-container *ngIf="countryCode === 'CO'">
      <div class="divider"></div>
      <div class="settings-tip">
        <p>Configuración de Propinas</p>
        <div class="settings-msi-options">
          <div class="settings-tip-option">
            <label class="form-control">
              <input type="checkbox" name="tip" [checked]="isTipEnabled" (change)="toggleTip($event)"/>
              Habilitar propina
            </label>
            <p class="settings-msi-subtext">Permite a tus clientes agregar una propina voluntaria al finalizar la compra.</p>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="countryCode !== 'CO' && countryCode !== 'MX'">
      <div>
        <p class="settings-error-section alert-warning">No hay configuraciones disponibles</p>
      </div>
    </ng-container>
  </div>
  <div class="settings-buttons">
    <button (click)="backTo('nuvemshop')" class="settings-buttons-back">Volver a Tiendanube</button>
    <button (click)="saveInstallments()" [disabled]="!installmentsIsChange" [ngClass]="installmentsIsChange == false ? 'disabledButton' : 'settings-buttons-save'" >Guardar</button>
  </div>
  <div class="settings-toast-success" *ngIf="successToast">
    <img src="assets/img/security/right@2x.png" alt="">
    <p>Los cambios se guardaron exitosamente.</p>
  </div>
</div>

<div class="settings-loader-section" *ngIf="loader">
  <img src="assets/img/Loader.gif" width="300">
  <p *ngIf="!initialLoader" style="font-size: 22px; font-weight: bold; margin-top: -70px">Estamos guardando los cambios</p>
  <p *ngIf="initialLoader" style="font-size: 22px; font-weight: bold; margin-top: -70px">Obteniendo información</p>
  <p style="font-size: 15px; color: #121212;">Por favor no actualices o cierres la pantalla <br> mientras completamos el proceso</p>
</div>

<div class="settings-error-section" *ngIf="errorSection">
  <img src="assets/img/error-icon/Icon@2x.png" width="48" height="48">
  <p style="font-size: 22px; font-weight: bold">No pudimos guardar los cambios</p>
  <p style="font-size: 15px; color: #121212;">Para poder ayudarte, envía un correo a<b> soporte@openpay.com</b> </p>
  <button (click)="backToNuvemshop()">Volver a Tiendanube</button>
</div>

<div class="settings-error-attempt-section" *ngIf="attemptErrorSection">
  <img src="assets/img/error-icon/Icon@2x.png" width="48" height="48">
  <p style="font-size: 22px; font-weight: bold">No pudimos guardar los cambios</p>
  <p style="font-size: 15px; color: #121212;">Por favor, intenta de nuevo o regresar más tarde.</p>
  <div>
    <button (click)="backToNuvemshop()" class="button-back">Volver a Tiendanube</button>
    <button (click)="saveInstallments()" class="button-try">Intentar de nuevo</button>
  </div>
</div>

<div class="settings-modal" *ngIf="modal">
  <div class="modal-dialog">
    <img src="assets/img/warning/caution@2x.png" width="24">
    <div class="modal-title">
      <span>¿Deseas salir sin guardar?</span>
    </div>
    <div class="modal-text">
      <span>Los cambios en tu tienda no se han guardado.</span>
    </div>
    <div class="modal-buttons">
      <button (click)="exit()" class="button-modal-back">Salir sin guardar</button>
      <button (click)="saveInstallments()" class="button-modal-save">Guardar</button>
    </div>
  </div>
</div>

